// extracted by mini-css-extract-plugin
module.exports = {"outerSpan":"SnackBar_outerSpan__7yWJH","outerSpanExpanded":"SnackBar_outerSpanExpanded__bVExn","innerSpan":"SnackBar_innerSpan__NCM_M"};